<template>
  <b-card
    class="earnings-card"
  >
    <b-card-title class="mb-1">
      Produk Registry Baru
    </b-card-title>
    <!-- chart -->
    <div class="d-flex justify-content-center">
      <vue-apex-charts
        height="160"
        :options="chartOptions"
        :series="chartData"
      />
    </div>
    <h2 class="mt-50 mb-1">
      {{ toThousands(totalProducts) }} <small>Barang</small>
    </h2>
    <b-card-text class="font-small-2 mb-0">
      <span>Internal: </span><span class="font-weight-bolder">{{ toThousands(totalInternal) }}</span>
      <br>
      <span>Eksternal: </span><span class="font-weight-bolder">{{ toThousands(totalEksternal) }}</span>
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      chartOption: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        stroke: { width: 0 },
        responsive: [
          {
            breakpoint: 1200,
            options: {
              chart: {
                height: 140,
              },
            },
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 120,
              },
            },
          },
        ],
      },
    }
  },
  computed: {
    totalProducts() {
      return this.data.reduce((total, el) => total + el.all_product_registry_count, 0)
    },
    totalInternal() {
      return this.data.reduce((total, el) => total + el.internal_product_registry_count, 0)
    },
    totalEksternal() {
      return this.data.reduce((total, el) => total + el.external_product_registry_count, 0)
    },
    chartData() {
      // eslint-disable-next-line radix
      return [parseInt(this.totalInternal), parseInt(this.totalEksternal)]
    },
    chartOptions() {
      return {
        ...this.chartOption,
        labels: ['Internal', 'Eksternal'],
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15,
                  formatter(val, global) {
                    const total = global.globals.seriesTotals[0] + global.globals.seriesTotals[1]
                    const percentage = (val / total) * 100
                    // eslint-disable-next-line radix
                    return `${percentage.toFixed(1)}%`
                  },
                },
                total: {
                  show: true,
                  offsetY: 15,
                  label: 'Internal',
                  formatter(val) {
                    const total = val.globals.seriesTotals[0] + val.globals.seriesTotals[1]
                    const percentage = (val.globals.seriesTotals[0] / total) * 100
                    return `${percentage.toFixed(1)}%`
                  },
                },
              },
            },
          },
        },
      }
    },
  },
}
</script>
